import React from 'react';
import '../style/Teaching.scss';
// react bootstrap
import { Container } from 'react-bootstrap';
import Header from '../components/public/Header';

function HowToRun() {
  return (
    <>
      <Header />
      <Container>
        <div className='content'>
          <h3 className='text-left text-secondary'>如何運行身</h3>
          <p className='chineseParagraph'>
            如何運行身
            人類生命的起源（胚胎的初始發育階段）根據藏醫和密續經典中的說法，生命開始於母親的卵子和父親的精子（紅菩提和白菩提）兩個種子在子宮中結合，並受到業力驅使意識時開始。從那一刻起，一個新受孕的胚胎通過母體胎盤中的臍帶輸送營養為食而發育。
            因此在整個胎兒發育的各個階段都起著重要的作用，妊娠9個月分為三個階段，在此階段胎兒的整個發育過程中，氣的能量變化起著關鍵作用。
          </p>
        </div>
      </Container>
    </>
  );
}

export default HowToRun;
